"use client";

import { c as _c } from "react/compiler-runtime";
import { useScroll } from "ahooks";
import { useEffect, useRef } from "react";
import { TrackingEventType, useTracking } from "./index";
export const ScrollDepthTracker = () => {
  const $ = _c(17);
  const {
    track
  } = useTracking();
  const scroll = useScroll();
  const maxExposureDepth = useRef(0);
  const hasReported = useRef(false);
  let t0;
  if ($[0] !== scroll) {
    t0 = () => {
      if (!scroll) {
        return 0;
      }
      const {
        top
      } = scroll;
      const windowHeight = window.innerHeight;
      const calculatePageContentLength = _temp;
      const getCurrentExposureLength = () => {
        const header_0 = (document.querySelector("header") as HTMLElement)?.offsetHeight || 0;
        return header_0 + top + windowHeight;
      };
      const pageContentLength = calculatePageContentLength();
      const currentExposureLength = getCurrentExposureLength();
      if (pageContentLength <= 0) {
        return 0;
      }
      const exposureDepth = parseFloat((currentExposureLength / pageContentLength * 100).toFixed(2));
      return Math.min(exposureDepth, 100);
    };
    $[0] = scroll;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const calculateExposureDepth = t0;
  let t1;
  if ($[2] !== track) {
    t1 = () => {
      if (hasReported.current) {
        return;
      }
      const currentDepth = maxExposureDepth.current;
      if (currentDepth > 0) {
        hasReported.current = true;
        try {
          track("PopMartGlobalWebHomePageExposureDepth", {
            depth: currentDepth
          }, TrackingEventType.ACTION);
        } catch {
          hasReported.current = false;
        }
      }
    };
    $[2] = track;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const reportExposureDepth = t1;
  let t2;
  if ($[4] !== calculateExposureDepth) {
    t2 = () => {
      const currentDepth_0 = calculateExposureDepth();
      if (currentDepth_0 > maxExposureDepth.current) {
        maxExposureDepth.current = currentDepth_0;
      }
    };
    $[4] = calculateExposureDepth;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== scroll) {
    t3 = [scroll];
    $[6] = scroll;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== reportExposureDepth) {
    t4 = () => {
      const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
          reportExposureDepth();
        }
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    };
    $[8] = reportExposureDepth;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== reportExposureDepth) {
    t6 = () => {
      const handleBeforeUnload = () => {
        reportExposureDepth();
      };
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    };
    $[11] = reportExposureDepth;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== reportExposureDepth) {
    t8 = () => () => {
      reportExposureDepth();
    };
    $[14] = reportExposureDepth;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  useEffect(t8, t9);
  return null;
};
function _temp() {
  const header = (document.querySelector("header") as HTMLElement)?.offsetHeight || 0;
  const banner = (document.querySelector("[data-module=\"banner\"]") as HTMLElement)?.offsetHeight || 0;
  const newArrivals = (document.querySelector("[data-module=\"new-arrivals\"]") as HTMLElement)?.offsetHeight || 0;
  const hotProducts = (document.querySelector("[data-module=\"hot-products\"]") as HTMLElement)?.offsetHeight || 0;
  const tabbedContent = (document.querySelector("[data-module=\"tabbed-content\"]") as HTMLElement)?.offsetHeight || 0;
  const productFlow = (document.querySelector("[data-module=\"product-flow\"]") as HTMLElement)?.offsetHeight || 0;
  const defaultProductFlowHeight = productFlow > 0 ? Math.min(productFlow, 1200) : 1200;
  const backToTopButton = (document.querySelector("[data-module=\"back-to-top\"]") as HTMLElement)?.offsetHeight || 0;
  return header + banner + newArrivals + hotProducts + tabbedContent + defaultProductFlowHeight + backToTopButton;
}